var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "overflow-y-hidden h-screen flex flex-col bg-gray-300",
      attrs: { id: "app" }
    },
    [
      _c(
        "t-alert",
        {
          attrs: {
            show: _vm.alertOpen,
            dismissible: "",
            timeout: _vm.alertTimeout,
            variant: _vm.alertVariant
          },
          on: { hidden: _vm.resetAlert }
        },
        [
          _c("div", { staticClass: "mr-8 text-sm" }, [
            _vm._v(_vm._s(_vm.alertText))
          ])
        ]
      ),
      _vm._v(" "),
      _c("jhi-navbar"),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }